export default __webpack_public_path__ + "static/media/logo.cd442d92.svg";